import { DeliveryStatusEnum } from "@/constants/enums/deliveryStatus.enum";
import { Badge } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDeliveryStatusLabels } from "@/hooks/useEnumLabels";

export const DeliveryStatusBadge = ({
  type,
  isBo = true,
}: {
  type: DeliveryStatusEnum | undefined;
  isBo?: boolean;
}) => {
  const deliveryStatusLabels = useDeliveryStatusLabels();
  const { t } = useTranslation("shared");
  switch (type) {
    case DeliveryStatusEnum.WAITING:
      return (
        <Badge
          variant="standard"
          className="rounded-xl border border-[#bfdbfe] bg-[#eff6ff] px-2 py-0.5 text-sm font-medium text-[#067AFF]"
        >
          {deliveryStatusLabels.WAITING}
        </Badge>
      );
    case DeliveryStatusEnum.ONGOING:
      return (
        <Badge
          variant="standard"
          className="rounded-xl border border-[#FEDF89] bg-[#FFFAEB] px-2 py-0.5 text-sm font-medium text-[#B54708]"
        >
          {deliveryStatusLabels.ONGOING}
        </Badge>
      );
    case DeliveryStatusEnum.BLOCKED:
      if (!isBo) {
        return (
          <Badge
            variant="standard"
            className="rounded-xl border border-[#FEDF89] bg-[#FFFAEB] px-2 py-0.5 text-sm font-medium text-[#B54708]"
          >
            {deliveryStatusLabels.ONGOING}
          </Badge>
        );
      }
      return (
        <Badge
          variant="standard"
          className="rounded-xl border border-red-200 bg-red-50 px-2 py-0.5 text-sm font-medium text-red-700"
        >
          {deliveryStatusLabels.BLOCKED}
        </Badge>
      );
    case DeliveryStatusEnum.DELIVERED:
      return (
        <Badge
          variant="standard"
          className="rounded-xl border border-[#ABEFC6] bg-[#ECFDF3] px-2 py-0.5 text-sm font-medium text-[#067647]"
        >
          {deliveryStatusLabels.DELIVERED}
        </Badge>
      );
    case DeliveryStatusEnum.PARTIALLY_DELIVERED:
      return (
        <Badge
          variant="standard"
          className="rounded-xl border border-[#FEDF89] bg-[#FFFAEB] px-2 py-0.5 text-sm font-medium text-[#B54708]"
        >
          {deliveryStatusLabels.PARTIALLY_DELIVERED}
        </Badge>
      );
    case DeliveryStatusEnum.TOTALLY_DELIVERED:
      return (
        <Badge
          variant="standard"
          className="rounded-xl border border-[#ABEFC6] bg-[#ECFDF3] px-2 py-0.5 text-sm font-medium text-[#067647]"
        >
          {deliveryStatusLabels.TOTALLY_DELIVERED}
        </Badge>
      );
    case DeliveryStatusEnum.FAILED:
      return (
        <Badge
          variant="standard"
          className="rounded-xl border border-red-200 bg-red-50 px-2 py-0.5 text-sm font-medium text-red-700"
        >
          {deliveryStatusLabels.FAILED}
        </Badge>
      );
    default:
      return (
        <Badge
          variant="standard"
          className="rounded-xl border border-gray-200 bg-gray-50 px-2 py-0.5 text-sm font-medium text-gray-700"
        >
          {t("badges.unknownValue")}
        </Badge>
      );
  }
};
